module.exports = __webpack_public_path__ + "static/media/dog.3aa9ccbe.svg";